var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0 11 1.222 11 1.222 9.796 2.571 9.796 2.571 8.559 3.728 8.559 3.728 7.289 4.992 7.289 4.992 6.089 6.203 6.089 6.203 11 7.478 11 7.478 9.796 8.777 9.796 8.777 8.559 10.048 8.559 10.048 7.289 11.237 7.289 11.237 6.089 12.48 6.089 12.48 11 15 11 15 0 12.48 0 12.48 4.918 11.237 4.918 11.237 3.607 10.048 3.607 10.048 2.543 8.777 2.543 8.777 1.269 7.5 1.269 7.5 0 6.203 0 6.203 4.918 4.992 4.918 4.992 3.607 3.728 3.607 3.728 2.543 2.571 2.543 2.571 1.269 1.222 1.269 1.222 0z",
    transform: "translate(-67 -318) translate(67 318) matrix(-1 0 0 1 15 0)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/back-button.32e4914bdf8732406547f72bd1c8d99f.svg";
export { ForwardRef as ReactComponent };